import router from './router'
import store from './store';
import Cookies from 'js-cookie'

const whiteList = ['/login', '/register', '/home'];

router.beforeEach((to, from, next) => {
  if (to.query.key) {
    Cookies.set('3d_token', to.query.key);
  }
  if (to.query.mainOrgId) {
    sessionStorage.setItem('mainOrgId', to.query.mainOrgId);
  }
  if (to.query.orgId) {
    sessionStorage.setItem('orgId', to.query.orgId);
  }
  if (to.query.coreParams) {
    sessionStorage.setItem('coreParams', to.query.coreParams);
  }
  next()
});

router.afterEach(() => {
});



// WEBPACK FOOTER //
// ./src/permission.js